<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button 
              :pressed="true"
              class="typo-label"
              variant="link"
               @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button 
              :pressed="false"
              class="typo-label"
              variant="link"
              @click="mostraMappa"
            >Mappa geografica</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && this.summaryPlants!=null && this.summaryPlants.length>0  && authorized" class="animated fadeIn container-fluid">
           
            <b-row>
                <b-col cols="12">
                    <div class="float-right typo-title pr-4 pt-3"><b>Dati aggiornati al : {{ this.jsonDateFormatted(this.summaryPlants[0].timestampFileJson)}}</b></div>
                </b-col>
            </b-row>

            <!-- componente cards di riepilogo impianti --> 
            <nto-summary-cards :plants="this.summaryPlants"></nto-summary-cards>

            <b-row class="mt-3 p-1">

                <!--- Grafico Impianti -->   
                <b-col cols="9">    
                    <b-form inline>
                    <label for="grafico1-year" class="typo-label">Andamento nuovi impianti su NuBe suddiviso per mese. {{this.$t('graph.period')}}:</label>
                                        
                    <b-form-select v-if="graficoPeriodo.indexOf('-') < 0" id="grafico1-year" v-model="graficoPeriodo" :options="graphPeriods" :value="''" class="ml-2" ></b-form-select>
                     <div v-else>
                                  <span  style="padding-left:10px">{{moment(graficoPeriodo, 'YYYY-MM').locale('it').format('MMMM YYYY')}}</span> <b-button @click="graficoPeriodo = ''">&laquo; Indietro</b-button>
                     </div>
                     
                    </b-form>
                </b-col>
                

                                
            </b-row>

            <b-row class="p-3 pb-5 mb-5">
                <b-col>
                <div style=" display: block"  class="mt-3">
                    <nto-grafico-impianti :key="keyGraph" :plants="this.summaryPlants" :anno="graficoPeriodo" v-on:selectedMonth="selectedMonth" />
                </div>
                </b-col>
            </b-row>                   


        </div>
        
    </div>

</template>

<script>

import NtoGraficoImpianti from '@/components/NTOGraficoImpianti'
import NtoSummaryCards from '@/components/NTOSummaryCards'
import { mapState, install } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'
import moment from 'moment'

export default {
    name: 'BAHome',
    components: {
        hideAt, 
        showAt,
        NtoGraficoImpianti,NtoSummaryCards
    },    
    props: [],
    data() {
        return {
            userId: null,
            pageloading: true,
            authorized: false,
            dataLoaded: false,
            tabPage: 1,
            graficoPeriodo: '',
            keyGraph:0,
            summaryPlants:[]
        }
    },

    mounted() {
        
        console.log("MOUNTED NTOSUMMARY " + this.$store.state.userSummaryPlants);
        if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
                const usertype = this.$store.getters.userType;
            if (usertype != 'analyst') {
                this.authorized = false;
                this.pageloading = false;
            } else {
                this.authorized = true;
                this.pageloading = true;
                this.dataLoaded = true;
                this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
            }
        }
    },

    updated() {
        if (this.summaryPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
           console.log("updated nto summary", this.summaryPlants);
        }
    },
    computed: {
        ...mapState(['loading']),
        
        graphPeriods() {
            var periods = [];
            var date = this.moment(new Date()).startOf('year');
            for (var i=0; i< 20; i++) {
                periods.push(date.format('YYYY'));
                date.subtract(1,'year');
            }
            periods.unshift({text:this.$t("graph.last_year"), value:''});
            return periods;
        },

        },  
     watch: {
        loading(val,oldval) {
            console.log("ntousers loading changed:" + val+ ", authorized=" + this.authorized+", pageLoading:" + this.pageloading);
            
            if (val == false && this.pageloading == true) {
                let self = this;
                if (! this.dataLoaded) {
                    const usertype = this.$store.getters.userType;
                    if (usertype == 'analyst') {
                        this.authorized = true;
                        this.pageloading = true;
                        this.dataLoaded = true;
                        this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
                    }
                    return;
                }
                this.summaryPlants = this.$store.state.userSummaryPlants;
                
                this.pageloading = false;
            }
        }  
    },        
    methods: {
       
        mostraRiepilogo() {
            router.push({ name: 'BAHome'})
        },

        mostraMappa() {
            router.push({ name: 'BAPlantsMap'})
        },
        
        jsonDateFormatted(da)
        {
            var d = new Date(da);
            var dateFormatted=d.getDate().toString() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();        //Usre getDate e non getDay che risponde un errore
            dateFormatted=dateFormatted+ " ore: " + d.getHours() + ":" + (d.getMinutes()) +":" +(d.getSeconds());
            return dateFormatted;
        },

        selectedMonth(value) {
            console.log("selected month",value);
            this.graficoPeriodo = value.month; 
        }
    }    

}
</script>